import React from 'react'

export const Support = () => {
    return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Support for SynckSnap</h1>
      <p>If you need assistance with the SynckSnap app, we're here to help.</p>
      <p>
        <strong>Email us:</strong>{' '}
        <a href="mailto:support@synckonnect.com" style={styles.link}>
          support@synckonnect.com
        </a>
      </p>
      <p>
        We aim to respond as quickly as possible. You can also reach us through
        our contact form or social media channels.
      </p>
      <p>Thank you for using SynckSnap!</p>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f7f9fc',
    color: '#333',
    padding: '40px',
    maxWidth: '600px',
    margin: 'auto',
  },
  heading: {
    color: '#2a6bff',
  },
  link: {
    color: '#2a6bff',
    textDecoration: 'none',
  },
};
